module.exports = __webpack_public_path__ + "media/images/favicon-144fd280486933da2a0c03dc8d70bee0.ico";